<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" :close-on-content-click="false" offset-y max-height="420" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      div(v-on="on")
        y-button(:label="getButtonText" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" prepend-icon="$yzi-filter-line" icon-color="neutral500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-2")
    
    .white
      .menu-header.white
        .font-semibold.text-sm.pa-4 Filter doctors
        v-text-field.text-sm.round-xl.mx-4.mb-3(v-model="searchText" @input="queryChanged" outlined :placeholder="$t('search')" dense hide-details)
        v-divider

      v-skeleton-loader.pa-4(v-if="isLoading" type="text@3")
      div(v-else)
        template(v-if="providers.length > 0")
          div(v-for="provider in providers" :key="provider.value")
            .d-flex.text-sm.px-4.py-3.cursor-pointer.hover-bg(@click="clickItem(provider)")
              yc-checkbox(:input-value="isChecked(provider.value)" @change="clickItem(provider)")
              .ml-4 {{ provider.label }}
            v-divider.basic300
        template(v-else)
          .text-center.py-8.text-xs.neutral500--text No doctors found
          
    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-2.border-t
        y-button(v-if="!noSelectedDoctors" label="Reset" underline size="xs" button-class="px-0" unset-min-width @click="resetData")
        v-spacer
        y-button(:label="$t('apply')" size="xs" button-class="px-2" @click="apply")
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['type'],
  data: () => ({
    showMenu: false,
    isLoading: true,
    searchText: '',
    providers: [],
    selectedDoctors: [],
    checkedDoctors: [],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      visitFilters: 'treatment/getVisitFilters',
      appointmentFilters: 'treatment/getAppointmentFilters',
    }),
    filters () {
      return this.type === 'visit' ? this.visitFilters : this.appointmentFilters
    },
    noSelectedDoctors () {
      return this.checkedDoctors.length === 0
    },
    getButtonText () {
      let text = 'All doctors'
      if (this.selectedDoctors.length > 1) {
        text = `${this.selectedDoctors.length} doctors selected`
      } else if (this.selectedDoctors.length === 1) {
        text = this.selectedDoctors[0].label
      }
      return text
    },
  },
  watch: {
    showMenu (value) {
      if (value) {
        this.setData()
      }
    }
  },
  mounted () {
    this.fetchProviders()
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.filters.doctors) {
        this.checkedDoctors = JSON.parse(JSON.stringify(this.filters.doctors))
        this.selectedDoctors = JSON.parse(JSON.stringify(this.filters.doctors))
      } else {
        this.checkedDoctors = []
        this.selectedDoctors = []
      }
    },
    fetchProviders () {
      this.isLoading = true
      const params = {
        fields: 'id,name',
        page_size: -1,
        search: this.searchText || ''
      }
      this.$axios.get(`/clinics/${this.company.slug}/providers`, { params })
      .then(resp => {
        if (resp.data?.results) {
          this.providers = resp.data.results.map(item => {
            return {
              label: item.name,
              value: `${item.id}`
            }
          })
        } else {
          this.providers = []
        }
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    resetData () {
      this.checkedDoctors = []
      this.apply()
    },
    apply () {
      let obj = { doctors: this.checkedDoctors }
      if (this.type === 'visit') {
        this.$store.commit('treatment/updateVisitFilters', obj)
      } else {
        this.$store.commit('treatment/updateAppointmentFilters', obj)
      }
      this.selectedDoctors = this.checkedDoctors
      this.$emit('change')
      this.showMenu = false
    },
    clickItem (item) {
      if (this.checkedDoctors.map(i => i.value).includes(item.value)) {
        this.checkedDoctors = this.checkedDoctors.filter(x => x.value !== item.value)
      } else {
        this.checkedDoctors.push(item)
      }
    },
    queryChanged: debounce(function () {
      this.fetchProviders()
    }, 750),
    isChecked (value) {
      return this.checkedDoctors.filter(item => item.value === value).length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}
</style>